import css from 'styled-jsx/css';

export default css`.default {
  display: flex;
  position: relative;
  width: 100%;
  min-height: 200px;
  font-size: 0;
  border-radius: 4px;
  padding-top: calc(80% + 15px);
  margin: 0 0 15px;
  animation-duration: .3s;
  animation-fill-mode: both;
  transition-duration: .4s;
  transition-property: top, left, transform;
  will-change: top, left, transform;
  overflow: hidden;
  box-sizing: border-box; }
  .default.BottomDFP {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    min-height: 50px;
    max-height: 100px; }
  @media (min-width: 768px) {
    .default.masonry-article {
      min-height: 225px; } }
  @media (min-width: 992px) {
    .default.masonry-article {
      min-height: 255px; } }
  @media (min-width: 1216px) {
    .default.masonry-article {
      min-height: 220px; } }
  .default::after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: '';
    clear: both;
    height: 0; }
  .default > * {
    box-sizing: border-box; }
  .default.isMobile {
    padding-top: calc(95% + 15px); }
  .default.isEmpty {
    display: none !important; }
  .default.isNotEmpty.isLoaded {
    padding-top: 0 !important; }
`